export const USER_RETENTION_MODAL_CONTENT = {
  original: {
    title: "Design not perfect? We can help!",
    beforeLabel: "Original Upload",
    beforeAlt: "Before",
    afterLabel: "Designer Perfected",
    afterAlt: "After",
    sampleMessageLabel: "Sample message to designer:",
    sampleMessageLines: [
      'Please remove the pink background, change the ribbon color to blue, remove freckles. Change "It\'s a girl!" to Emma.'
    ],
    sampleMessageAsList: false,
    buttonText: { desktop: "Request Artist Edits for Free", mobile: "Use Free Artist Edit" },
    imagePaths: { before: "2/gen/before.png", after: "2/gen/after.png" },
    changes: {
      desktop: ["Ribbon color changed", "Freckles removed", "Background removed", "Text changed"],
      mobile: ["Ribbon changed", "Freckles removed", "Background removed", "Text changed"]
    }
  },
  pin: {
    title: "Design Not Perfect? We Can Help!",
    beforeLabel: "Original Upload",
    beforeAlt: "Before",
    afterLabel: "Artist Edited",
    afterAlt: "After",
    sampleMessageLabel: "Sample message to Artist:",
    sampleMessageLines: [
      'Add the text "#1 Fan" in white color onto the blue flag.',
      "Change the color of the dog's t-shirt from blue to red."
    ],
    sampleMessageAsList: true,
    buttonText: { desktop: "Get Free Artist Edits", mobile: "Get Free Artist Edits" },
    imagePaths: {
      before: "2/gen/user-retention-modal-pin-before.png",
      after: "2/gen/user-retention-modal-pin-after.png"
    },
    changes: null
  }
} as const;

export const USER_RETENTION_MODAL_SHOWN_KEY = "IS_DTF_USER_RETENTION_MODAL_SHOWN";

export const MODAL_TRIGGER_POINTS = {
  EXIT_INTENT: "exit_intent",
  NONE: "none"
} as const;

export type ModalTriggerPoint = (typeof MODAL_TRIGGER_POINTS)[keyof typeof MODAL_TRIGGER_POINTS];
